import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Swal from 'sweetalert2'
import db from "./Firebase";
import { storage } from './Firebase';
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import Moment from 'moment';
import { extendMoment } from 'moment-range';

function WorkshopTag() {

    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [show, setshow] = useState(true);
    const [addTrends, setAddTrends] = useState(false);
    const [progresspercent, setProgresspercent] = useState(0);

    const [editID, setEditID] = useState("");
    const [languageID, setLanguageID] = useState("english");

    const [searchQuery, setSearchQuery] = useState("");
    const [availabilityFilter, setAvailabilityFilter] = useState("all");


    useEffect(() => {
        setLanguageID("english")
        db.collection("workshop_event_data").orderBy("created_date", "desc").onSnapshot((snapshot) => {

            setData(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
        });

    }, []);

    // Step 3: Filter data based on search query and availability filter
    const filteredData = data.filter((record) => {
        return (
            record.data.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
            (availabilityFilter === "all" || (availabilityFilter === "available" && record.data.recorded_session) || (availabilityFilter === "notAvailable" && !record.data.recorded_session))
        );
    });


    // // Step 3: Filter data based on search query
    // const filteredData = data.filter((record) => {
    //     return record.data.name.toLowerCase().includes(searchQuery.toLowerCase());
    // });

    const handleSearch = (e) => {
        setSearchQuery(e.target.value); // Step 3: Update search query state
    }

    const handleAvailabilityFilter = (e) => {
        setAvailabilityFilter(e.target.value); // Step 2: Update availability filter state
    }

    const change = () => {
        setLanguageID("hindi")
        db.collection("workshop_event_data_hindi").orderBy("created_date", "desc").onSnapshot((snapshot) => {

            setData(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
        });
    }

    const changeE = () => {
        setLanguageID("english")
        db.collection("workshop_event_data").orderBy("created_date", "desc").onSnapshot((snapshot) => {

            setData(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
        });
    }


    const changeStatus = async (uid) => {

        const { value: text } = await Swal.fire({
            input: 'text',
            inputLabel: 'Workshop Tag',
            inputPlaceholder: 'Enter Tag here...'
        })

        if (text) {
            // Swal.fire(`Entered text: ${text}`)
            db.collection("workshop_event_data").doc(uid).update({ 'tag': text, }).then(() => {
                console.log("tag added");
            })
        }

    }

    const changeStatusH = async (uid) => {

        const { value: text } = await Swal.fire({
            input: 'text',
            inputLabel: 'Workshop Tag',
            inputPlaceholder: 'Enter Tag id here...'
        })

        if (text) {
            // Swal.fire(`Entered text: ${text}`)
            db.collection("workshop_event_data_hindi").doc(uid).update({ 'tag': text, }).then(() => {
                console.log("tag added");
            })
        }

    }

    const changeStatusTS = async (uid, data) => {

        const { value: text } = await Swal.fire({
            input: 'textarea',
            inputLabel: 'Recorded Video TimeStamp',
            inputPlaceholder: 'Enter TimeStamp here...',
            inputValue: data,
        })

        if (text) {
            // Swal.fire(`Entered text: ${text}`)
            db.collection("workshop_event_data").doc(uid).update({ 'uid': text, }).then(() => {
                console.log("timestamp added");
            })
        }

    }

    const changeStatusTSH = async (uid, data) => {

        const { value: text } = await Swal.fire({
            input: 'textarea',
            inputLabel: 'Recorded Video TimeStamp',
            inputPlaceholder: 'Enter TimeStamp here...',
            inputValue: data,

        })

        if (text) {
            // Swal.fire(`Entered text: ${text}`)
            db.collection("workshop_event_data_hindi").doc(uid).update({ 'uid': text, }).then(() => {
                console.log("timestamp added");
            })
        }

    }

    const handleExport = () => {
        const rows = filteredData.map((item, index) => ({
            "Sr. No": index + 1,
            "Workshop Name": item.data.name || "",
            "Tag": item.data.tag || "",
            "Language": languageID === "english" ? "English" : "Hindi",
        }));
        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "WorkshopTags");
        const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        saveAs(
            new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
            `WorkshopTags_${languageID}_${new Date().toISOString().slice(0, 10)}.xlsx`
        );
    };

    const view = async (data) => {
        const { value: text } = await Swal.fire({
            input: 'textarea',
            inputLabel: 'Recorded Video TimeStamp',
            inputPlaceholder: 'Enter TimeStamp here...',
            inputValue: data,
            inputAttributes: {
                readOnly: true, // Make the textarea read-only
            },
            showCancelButton: false,
            showCloseButton: false,
            showConfirmButton: false,
        })
    }




    return (
        <>
            <div class="p-3">
                {languageID === "english" ?
                    <>
                        <div class="" style={{ float: "right" }}><button type="button" class="btn btn-sm" style={{ backgroundColor: "cadetblue", color: "white", marginRight: "1rem", marginBottom: "10px" }} onClick={() => change()}>Go To Workshop Hindi</button></div>
                    </>
                    :
                    <>
                        <div class="" style={{ float: "right" }}><button type="button" class="btn btn-sm" style={{ backgroundColor: "cadetblue", color: "white", marginRight: "1rem", marginBottom: "10px" }} onClick={() => changeE()}>Go To Workshop English</button></div>
                    </>}

                <input
                    type="text"
                    className="form-control form-control-sm mb-2"
                    placeholder="Search by Workshop Name"
                    value={searchQuery}
                    onChange={handleSearch}
                />

                <div className="d-flex align-items-center gap-2 mb-2">
                    <label class="mr-3 mb-0">Recording: </label>
                    <select value={availabilityFilter} onChange={handleAvailabilityFilter} className="form-control-sm">
                        <option value="all">All</option>
                        <option value="available">Available</option>
                        <option value="notAvailable">Not Available</option>
                    </select>
                    <button
                        className="btn btn-success btn-sm"
                        onClick={handleExport}
                        disabled={filteredData.length === 0}
                    >
                        Export Excel
                    </button>
                    <span style={{ fontSize: "13px", color: "#6c757d" }}>{filteredData.length} records</span>
                </div>

                <div class="table-responsive fix-width scroll-inner">
                    <table class="table table-bordered table-hover">
                        <thead class="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Sr. No</th>
                                <th>Workshop Name</th>
                                <th>Tag</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData?.map(({ id, data }, index) => (
                                <>
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>{data.name}</td>
                                        <td>{data.tag}</td>
                                        <td>
                                            {languageID === "english" ? <><span style={{ color: "orange", fontSize: "13px", fontWeight: "700", cursor: "pointer" }} onClick={() => changeStatus(id)}>Update Tag</span></> : <><span style={{ color: "orange", fontSize: "13px", fontWeight: "700", cursor: "pointer" }} onClick={() => changeStatusH(id)}>Update Tag</span></>}

                                        </td>

                                    </tr>
                                </>
                            ))}


                        </tbody>
                    </table>
                </div>
            </div>



        </>
    )
}

export default WorkshopTag
